import React, {Component} from 'react';
import {connect} from "react-redux";
import {Button, Col, Row, TabContent, TabPane} from "reactstrap";
import * as actions from "../../actions/index";
import {priceList} from "../../util/broadcaster/profile_util";
import {Field, reduxForm} from "redux-form";
import {isEmpty, required, vuepayAlert} from "../../util/utility";
import {renderTextAreaField} from "../../util/account_management";
import {getData, LOGIN} from "../../util/storage";
import {checkIfCreateBroadcast} from "../../util/broadcast";
import {updateJWTToken} from "../../util/broadcast/create";
import {acceptPaidGroupRequest} from "../../util/firebase/firestore";
//image
import loading_white from '../../assets/gif/loading_white.gif';
import assets from "../../util/assets";

class GroupRequest extends Component {

    constructor() {
        super();

        this.state = {
            count: 0,
            formData: null,
            optionTemplate: priceList().map(v => (<option key={v} value={v}>{parseFloat(v / 100).toFixed(2)}</option>))
        }

        //all the functions used in this component should be listed here for better documentation
        this.onSubmit = this.onSubmit.bind(this);
        this.textAreaChange = this.textAreaChange.bind(this);
    }

    componentDidMount() {

        /**
         * update the status of the button along with the text size for session description
         */
        this.setState({
            count: this.props.initialValues.session_description.length,
            broadcast_type: "paid"
        })
    }

    UNSAFE_componentWillReceiveProps(nextProps) {

        if (checkIfCreateBroadcast(nextProps)) {

            if (nextProps.broadcast.payload.status_code === 201) {

                const payload = nextProps.broadcast.payload;
                //if the status_code received from the server is 201 means the broadcast was created successfully
                nextProps.resetCreateBroadcast();

                updateJWTToken(payload, () => {

                    // add paid group node in firestore
                    acceptPaidGroupRequest(this.props.initialValues.id.toString(), nextProps.broadcast.payload.data.id.toString(), {price: this.state.formData.group_session_price}, () => {
                        this.props.disconnectFromTokBoxAndChangeBroadcast(nextProps.broadcast.payload.data)
                    })


                });

                vuepayAlert("success", payload.message);

            } else {
                //if the status_code received from the server is NOT 200 means there has been some error occurred
                nextProps.resetCreateBroadcast();
                nextProps.resetUpdateBroadcast();
                vuepayAlert("error", nextProps.broadcast.payload.message);
            }
        }

    }


    submitBroadcasterAcceptRequest = (requestIds) => {

        console.log("submitBroadcasterAcceptRequest", requestIds);
        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                let acceptData = {
                    request_id: null,
                    request_ids: requestIds,
                    request_type: "group",
                };

                //flag to parent that we have initiated a group broadcast
                this.props.updateBroadcasterType("group");

                this.props.broadcasterAcceptRequest(
                    data.token,
                    data.api_token,
                    this.props.availabilityID,
                    acceptData
                );
            }
        });
    };

    onSubmit(values) {
        if (this.props.availabilityID === -1) {
            const formData = {
                session_title: this.props.initialValues.session_title,
                session_description: values.session_description,
                broadcast_type: "paid",
                one_to_one_session_allow: this.props.initialValues.one_to_one_session_allow,
                one_to_one_session_price: this.props.initialValues.one_to_one_session_price,
                group_session_price: parseInt(document.getElementsByName("group_session_price")[0].value),
                is_chat_allowed: true,
                is_hls: false,
                device: this.props.device,
                broadcast_id: this.props.initialValues.id.toString()
            };

            this.setState({
                formData: formData
            });

            getData(LOGIN)
                .then((data) => {
                    if (!isEmpty(data)) {
                        //this.props.createBroadcast(data.token, data.api_token, formData);
                        /**
                         * @business_rule
                         * if the user has changed only session title and session description then call updateBroadcast
                         * else call createBroadcast
                         */
                        this.props.createBroadcast(data.token, data.api_token, formData);
                    }
                })
        } else {
            let requestIDs = [];
            this.props.groupRequestArray.map((request) => {
                requestIDs.push(request.id);
            });
            console.log("onSubmit >> requestIDs", requestIDs)
            this.submitBroadcasterAcceptRequest(requestIDs);
        }
    }

    /**
     * @function listener for text area change we use this to maintain the count of the characters the user has typed
     * @param e
     */
    textAreaChange(e) {
        this.setState({
            count: e.target.value.length,
        });
    }


    render() {
        const {groupRequestArray} = this.props;
        const {handleSubmit} = this.props;

        return (
            <div className="wrapper-content">
                {
                    (
                        this.props.initialValues.broadcast_type === "free"
                        &&
                        <div>
                            {

                                <div className="wrapper-content change-broadcast">
                                    <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                                        <div>
                                            {
                                                this.props.availabilityID === -1 &&
                                                <div>
                                                    <dl>
                                                        <dt className="thing-enter">
                                                            Set group price
                                                        </dt>
                                                        <dd className="thing-enter">
                                                            <Field className="custom-select"
                                                                   name="group_session_price"
                                                                   component="select">
                                                                {this.state.optionTemplate}
                                                            </Field>
                                                            <span>£/min</span>
                                                        </dd>
                                                    </dl>
                                                </div>
                                            }

                                            <div>
                                                {
                                                    this.props.availabilityID === -1 &&
                                                    <dl>
                                                        <dt className="thing-enter">Session description</dt>
                                                        <dd >
                                                            <div className="form-group">
                                                                <Field
                                                                    label=""
                                                                    name="session_description"
                                                                    maxLength="280"
                                                                    minLength="1"
                                                                    onBlur={this.textAreaChange}
                                                                    height={"153px"}
                                                                    count={this.state.count}
                                                                    validate={[required]}
                                                                    component={renderTextAreaField}
                                                                    onChange={this.textAreaChange}
                                                                />
                                                            </div>
                                                        </dd>
                                                        <br/>
                                                    </dl>
                                                }

                                                <Row>
                                                    {/*{*/}
                                                        {/*this.props.broadcast.isFetching ?*/}
                                                            {/*<button*/}
                                                                {/*className="btn btn-outline-primary w-100"*/}
                                                                {/*type="button">*/}
                                                                {/*<img src={loading_white} alt={"Loading"}*/}
                                                                     {/*width={26}*/}
                                                                     {/*height={26}/>*/}
                                                            {/*</button>*/}
                                                            {/*:*/}
                                                            {/*<button*/}
                                                                {/*className="btn btn-outline-primary">Confirm*/}
                                                                {/*session</button>*/}
                                                    {/*}*/}

                                                    <Col md="12" sm="12" className="text-center">
                                                        <Button
                                                            color="primary"
                                                            className="request-button confirm-group-session-btn">
                                                            {this.props.broadcast.isFetching ? (
                                                                <img
                                                                    src={assets.loading_white}
                                                                    alt={"Loading"}
                                                                    width={26}
                                                                    height={26}
                                                                />
                                                            ) : (
                                                                "CONFIRM SESSION"
                                                            )}
                                                        </Button>
                                                    </Col>

                                                </Row>
                                            </div>
                                        </div>

                                    </form>
                                </div>

                            }


                        </div>

                    )
                }
            </div>
        );
    }
}

//
// Decorate with reduxForm(). It will read the initialValues prop provided by connect()
GroupRequest = reduxForm({
    form: 'GroupRequestForm', // a unique identifier for this form
    enableReinitialize: true
})(GroupRequest);


function mapStateToProps(state, ownParams) {
    return {
        broadcast: state.broadcast,
        device: state.device.payload
    };
}

export default connect(mapStateToProps, actions)(GroupRequest);